import { useSelector } from 'react-redux';
import ResourceLibrary from '../../../../components/resourceLibrary';
import { useAppDispatch } from '../../../../store';
import { File, Template, UploadBusinessType } from '../../../../types';
import {
  selectDraftTemplate,
  updateDraftTemplate,
} from '../../../../slices/templates';
import { updateTemplate } from '../../../../utils/httpRequest';

const TemplateResourceLibrary = () => {
  const dispatch = useAppDispatch();
  const template = useSelector(selectDraftTemplate);

  const handleUpdateDocuments = async (documents: File[]) => {
    const res = await updateTemplate({
      ...template,
      documents,
    } as Template);

    dispatch(updateDraftTemplate(res.data));
  };

  return (
    <ResourceLibrary
      documents={template?.documents}
      templateID={template?.templateID}
      uploadBusinessType={UploadBusinessType.TEMPLATE}
      onUpdateDocuments={handleUpdateDocuments}
    />
  );
};

export default TemplateResourceLibrary;
